import React, { useEffect, useState } from 'react';
import { Star, Quote } from 'lucide-react';
import { svcListTestimonials } from '@/services/entitiesService';

export default function TestimonialsSection() {
  const [items, setItems] = useState([]);
  useEffect(() => { svcListTestimonials().then(setItems).catch(() => setItems([])); }, []);
  if (!items || items.length === 0) return null;

  return (
    <section className="my-12 bg-[#1B2A4A] text-white py-12" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8">
          <span className="inline-block bg-[#F8D13F] text-[#1B2A4A] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">Testimonios</span>
          <h3 className="text-3xl md:text-4xl font-extrabold mt-3">Lo que dicen nuestras clientas</h3>
        </div>
        <div className="grid md:grid-cols-3 gap-4">
          {items.slice(0, 6).map((t) => (
            <article key={t.id} data-testid={`testimonial-${t.id}`} className="bg-white/5 border border-white/10 rounded-2xl p-5 relative backdrop-blur">
              <Quote size={28} className="text-yellow-300 opacity-40 absolute top-3 right-3" />
              <div className="flex gap-3 items-center mb-3">
                {t.photo ? (
                  <img src={t.photo} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-yellow-300" loading="lazy" />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-yellow-300 text-[#1B2A4A] flex items-center justify-center font-bold">{(t.name || '?').slice(0, 1).toUpperCase()}</div>
                )}
                <div>
                  <div className="font-bold text-white text-sm">{t.name}</div>
                  {t.city && <div className="text-xs text-white/60">{t.city}</div>}
                </div>
              </div>
              <div className="flex mb-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={14} fill={i < (t.rating || 5) ? '#F8D13F' : 'transparent'} stroke={i < (t.rating || 5) ? '#F8D13F' : '#666'} />
                ))}
              </div>
              <p className="text-sm text-white/80 leading-relaxed">{t.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
